import { render } from "./Applicant.vue?vue&type=template&id=08f1f253"
import script from "./Applicant.vue?vue&type=script&lang=js"
export * from "./Applicant.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/app.rizome-bxl.be/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__